(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-lead-capture"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function(event) {
    if (event.target.id !== 'CourseLeadCapture') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'ad_course_lead_submitted'});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-program"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-course-booking-open]');
    if (!trigger) return;
    var bookingButton = document.getElementById('ad-cal-open');
    if (bookingButton) bookingButton.click();
  });

  } catch(e) { console.error(e); }
})();
})();
